<template>
  <div>
    <modal id="modal-new-setup-package-wiki" v-model="modal" :backdrop="false" class="skintestblock" size="lg">
      <h4 slot="title" class="smalltitle">{{ getTitleModal }}</h4>
      <div class="block-body">
        <div class="prolabel note">Name</div>
        <div class="profield"><input v-model="serviceItem.name" type="text"></div>
        <div class="prolabel note">
          Permission
          <label class="inline-checkbox">
            <input v-model="allSelected" type="checkbox" @click="selectAll">
            <strong>Check All</strong>
          </label>
        </div>
        <div class="profield"></div>
        <div class="" style="display: block;width: 100%;font-size: 13px">
          <div class=" radiogroup" style="text-transform: uppercase !important;">
            <div v-for="permission in listPermissions" class="col-item-permission" :key="permission.code">
              <label :title="getTitlePermission(permission)" class="inline-checkbox">
                <input v-if="permission.code"
                       v-model="serviceItem.permissions"
                       :value="permission.code"
                       type="checkbox"
                       @click="selectPermission(permission.code, permission)"
                >
                <strong :title="permission.hover">{{ permission.name }}</strong>
              </label>
              <div v-for="subPermission in permission.children"
                   v-if="permission.children" :key="subPermission.code"
                   :title="getTitlePermission(subPermission)"
                   class="sub-permission"
              >
                <label class="inline-checkbox">
                  <input v-model="serviceItem.permissions"
                         :value="subPermission.code"
                         v-if="subPermission.code"
                         type="checkbox"
                         @click="selectPermission(subPermission.code, permission)"
                  >
                  <span :title="subPermission.hover">{{ subPermission.name }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-default" type="button" @click.prevent="saveAction()">
          <i v-if="processing" class="fas fa-spinner fa-spin"></i>
          <span v-if="isEdit">Save</span>
          <span v-if="!isEdit">Create</span>
        </button>
        <button class="btn btn-default" type="button" @click.prevent="modal = false">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from '../../../client'
import Common from '../../mixins/Common'

export default {
  name: 'ModalNewSetupPackageWiki',
  mixins: [Common],
  props: {
    serviceEdit: {}
  },
  data () {
    return {
      modal: false,
      processing: false,
      serviceItem: {
        name: '',
        permissions: []
      },
      listPermissions: [],
      allSelected: false
    }
  },
  mounted () {
    this.getDetail()
    this.modal = true
    $('#modal-new-setup-package-wiki').find('.modal-dialog').addClass('modal-max')
  },
  computed: {
    getTitleModal () {
      if (this.serviceEdit) {
        return 'Edit Wiki package'
      }
      return 'Create New Wiki Package'
    },
    isEdit () {
      return !!this.serviceEdit
    }
  },
  watch: {
    modal (newValue) {
      this.$emit('updateModal', newValue)
    }
  },
  methods: {
    selectAll () {
      if (!this.allSelected) {
        this.listPermissions.forEach(permission => {
          let code = permission.code
          if (code && this.serviceItem.permissions.indexOf(code) < 0) {
            this.serviceItem.permissions.push(code)
          }
          if (permission.children && permission.children.length) {
            permission.children.forEach(child => {
              let codeChild = child.code
              if (codeChild && this.serviceItem.permissions.indexOf(codeChild) < 0) {
                this.serviceItem.permissions.push(codeChild)
              }
            })
          }
        })
      } else {
        this.serviceItem.permissions = []
      }
    },
    selectPermission (code, mainRole) {
      const isMainRole = code === mainRole.code
      if (isMainRole) {
        if (this.serviceItem.permissions.indexOf(code) >= 0) {
          const listRemoved = []
          if (mainRole.children) {
            mainRole.children.forEach(child => {
              if (child.code) listRemoved.push(child.code)
            })
          }
          this.serviceItem.permissions = this.serviceItem.permissions.filter(item => !listRemoved.includes(item))
        } else {
          if (mainRole.children) {
            mainRole.children.forEach(child => {
              if (child.code && this.serviceItem.permissions.indexOf(child.code) < 0) {
                this.serviceItem.permissions.push(child.code)
              }
            })
          }
        }
        return
      }
      if (code && this.serviceItem.permissions.indexOf(code) >= 0) {
        this.allSelected = false
        return
      }
      if (code && this.serviceItem.permissions.indexOf(code) < 0) {
        if (mainRole.code && this.serviceItem.permissions.indexOf(mainRole.code) < 0) {
          this.serviceItem.permissions.push(mainRole.code)
        }
      }
    },
    getTitlePermission (item) {
      return item.hover ? item.hover : ''
    },
    async getDetail () {
      try {
        let response = await axios.get(`/setup-package-wiki/get-data-create`, {
          params: {
            packageId: this.serviceEdit ? this.serviceEdit.id : ''
          }
        })
        if (response.data.s === 200) {
          this.modal = true
          const serviceItem = response.data.data.service
          if (serviceItem) {
            this.serviceItem.name = serviceItem.name
            this.serviceItem.permissions = serviceItem.permissions
          }
          this.listPermissions = response.data.data.DEFAULT_PERMISSIONS
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError('Server error when get data of package. Try again')
      }
    },
    validateForm () {
      if (!this.serviceItem.name) {
        return { s: false, msg: 'Please enter name' }
      }
      if (this.serviceItem.permissions.length === 0) {
        return { s: false, msg: 'Please choose permission' }
      }
      return { s: true }
    },
    async saveAction () {
      if (this.isEdit) {
        await this.updateService()
        return
      }
      await this.createService()
    },
    async updateService () {
      if (this.processing) return
      let validate = this.validateForm()
      if (!validate.s) {
        this.alertError(validate.msg)
        return
      }
      try {
        this.processing = true
        let response = await axios.put(`/setup-package-wiki/${this.serviceEdit.id}`, this.serviceItem)
        this.processing = false
        if (response.data.s === 200) {
          this.$emit('createNew', {})
          this.modal = false
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processing = false
        this.alertError('Server error. Try again')
      }
    },
    async createService () {
      if (this.processing) return
      let validate = this.validateForm()
      if (!validate.s) {
        this.alertError(validate.msg)
        return
      }
      try {
        this.processing = true
        let response = await axios.post(`/setup-package-wiki`, this.serviceItem)
        this.processing = false
        if (response.data.s === 200) {
          this.$emit('createNew', {})
          this.modal = false
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processing = false
        this.alertError('Server error. Try again')
      }
    }
  }
}
</script>
<style>
#modal-new-setup-package-wiki .modal-max {
  width: 98% !important;
}
</style>
<style scoped>
label.inline-checkbox {
  padding-right: 0 !important;
}

.col-item-permission {
  width: 20%;
  float: left;
  display: block;
}

.sub-permission {
  margin-left: 15px;
}
</style>
